"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function calculateBorderColor(borderColor) {
  return borderColor;
}

exports.calculateBorderColor = calculateBorderColor;

exports.border = function (_a) {
  var sizeBorderWidth = _a.sizeBorderWidth,
      colorBorder = _a.colorBorder;
  return {
    borderStyle: 'solid',
    borderWidth: sizeBorderWidth,
    borderColor: calculateBorderColor(colorBorder.normal)
  };
};